module.exports = __webpack_public_path__ + "media/Images/SwirlPink2-abd7846f.svg";